import getVideoId from 'get-video-id';

// ฟังก์ชันตรวจสอบประเภท URL
const getMediaType = (url: string) => {
    const { service } = getVideoId(url) || {};

    // ตรวจสอบ video platforms
    if (service === 'youtube' || service === 'vimeo' || service === 'dailymotion') {
        return service;
    }

    // ตรวจสอบไฟล์วิดีโอ
    if (url.match(/\.(mp4|webm|ogg|avi|mov)$/i)) {
        return 'video';
    }
    // ตรวจสอบไฟล์รูปภาพ
    if (url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
        return 'image';
    }
    return 'unknown';
};


// ฟังก์ชันสร้าง Embed URL
const getEmbedUrl = (url: string) => {
    const videoData = getVideoId(url);

    if (!videoData) return "";
    const { id, service } = videoData;
    switch (service) {
        case 'youtube':
            return `https://www.youtube.com/embed/${id}`;
        case 'vimeo':
            return `https://player.vimeo.com/video/${id}`;
        case 'dailymotion':
            return `https://www.dailymotion.com/embed/video/${id}`;
        default:
            return "";
    }
};

// Component สำหรับแสดง Media แต่ละประเภท
type renderItemMedia = {
    item: {
        img: string,
        url: string,
        alt?: string
        poster?: string
    }
}
export const MediaItem: React.FC<renderItemMedia> = ({ item }) => {
    const mediaType = getMediaType(item.img || item.url);

    switch (mediaType) {
        case 'youtube':
            return (
                <div className="aspect-video w-full">
                    <iframe
                        src={getEmbedUrl(item.img || item.url)}
                        title={item.alt || 'YouTube Video'}
                        className="w-full h-full rounded-lg"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            );

        case 'video':
            return (
                <video
                    controls
                    className="w-full h-auto rounded-lg"
                    src={item.img || item.url}
                    poster={item.poster}
                >
                    Your browser does not support the video tag.
                </video>
            );

        case 'image':
            return (
                <img
                    src={item.img || item.url}
                    alt={item.alt || 'Image'}
                    className="w-full h-auto object-cover rounded-lg"
                    style={{ aspectRatio: '1/1' }}
                />
            );

        default:
            return (
                <div className="w-full h-32 bg-gray-200 rounded-lg flex items-center justify-center">
                    <span className="text-gray-500">Unsupported media type</span>
                </div>
            );
    }
};